import Vue from 'vue';
export const EventBus = new Vue();

export function getEventBus() {
  return EventBus
}


// WEBPACK FOOTER //
// ./src/api/eventBus.js